export default __webpack_public_path__ + "static/media/clinical_Virology_Log.023fc350.png";